<template>
    <div>
        <!-- ********************************************************************************** -->
        <!-- This is the original code. was removed to display ordered list correctly. -->
        <!-- <div v-html="question_html" class="v-html flex-grow-1"></div> -->
        <!-- ********************************************************************************** -->

        <TipTap
            v-model="question.content.question"
            :menu_items="[]"
            :readonly="true"
            :is_walkthrough="is_walkthrough"
        />

    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
export default {
    data: () => ({}),
    props: ['question', 'question_html', 'is_walkthrough'],
    components: {
        TipTap: () => import('@/components/tiptap/TipTap')
    },
    methods: {}
}
</script>
